import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';
import { PLATFORM_NAME, ORG_NAME, copyrightLine } from '../config/brand';
import '../styles/LandingPage.css';

const ASSESSMENT_POINTS = [
  'See assigned assessments on your dashboard — in progress, upcoming, and completed.',
  'Write and run code in the exam workspace during the scheduled window.',
  'Submit when you are done; your attempt is scored after submission.',
];

const LandingPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (isAuthenticated) navigate('/dashboard', { replace: true });
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (isAuthenticated) return null;

  return (
    <div className="lp lp--minimal">
      <nav className={`lp-nav${scrolled ? ' lp-nav--scrolled' : ''}`}>
        <div className="lp-nav-inner">
          <Link to="/" className="lp-brand">
            <img src="/newlogo.png" alt={PLATFORM_NAME} className="lp-logo" />
          </Link>
          <div className="lp-nav-actions">
            <Link to="/login" className="lp-btn lp-btn--ghost">Student Login</Link>
            <Link to="/register" className="lp-btn lp-btn--primary">Register</Link>
          </div>
        </div>
      </nav>

      <main className="lp-main">
        <header className="lp-hero lp-hero--minimal">
          <div className="lp-hero-inner">
            <p className="lp-eyebrow">{ORG_NAME}</p>
            <h1 className="lp-title">Coding assessments for students</h1>
            <p className="lp-sub">
              {PLATFORM_NAME} is where you take assigned coding tests from your
              training centre — register, open your dashboard, and complete each
              assessment in its time window.
            </p>
            <div className="lp-hero-actions">
              <Link to="/register" className="lp-btn lp-btn--primary lp-btn--lg">
                Create account
              </Link>
              <Link to="/login" className="lp-btn lp-btn--ghost lp-btn--lg">
                Student Login
              </Link>
            </div>
          </div>
        </header>

        <section className="lp-panel" aria-label="How assessments work">
          <div className="lp-wrap">
            <ul className="lp-checklist">
              {ASSESSMENT_POINTS.map((text) => (
                <li key={text}>{text}</li>
              ))}
            </ul>
            <p className="lp-panel-note">
              Use the registration link from your instructor if your batch should
              be preselected at sign-up.
            </p>
          </div>
        </section>
      </main>

      <footer className="lp-footer lp-footer--minimal">
        <div className="lp-wrap lp-footer-inner">
          <div className="lp-footer-links">
            <Link to="/faq">FAQ</Link>
            <Link to="/contact-us">Contact</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
          </div>
          <p className="lp-copy">{copyrightLine()}</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
